<i18n>
    [
        "product__colorInfo--label",
    ]
</i18n>
<template>
    <div class="c-color-size-selector-wrapper">
        <div class="o-text--caption u-spacer--1">
            {{ t('product__colorInfo--label') }}:
            <span class="u-text--gray">
                {{ selectedChoice.color?.displayName }}
            </span>
        </div>
        <ColorSelector
            :id="id"
            :choices="choices"
            :selectedChoice="selectedChoice"
            :sizeCodeAvailibilityByChoiceId="sizeCodeAvailibilityByChoiceId"
            :selectedSkuSizeCode="selectedSkuSizeCode?.code"
            :updateSelectedColor="updateSelectedColor"
        />
        <ColorSizeSelector
            :id="id"
            :class="colorSizeSelectorSpacer"
            :selectedChoice="selectedChoice"
            :colorCode="colorCode"
            :sizeCodeAvailibilityByChoiceId="sizeCodeAvailibilityByChoiceId"
            :selectedSku="selectedSku"
            :selectedSkuSizeCode="selectedSkuSizeCode"
            :addToBoxError="addToBoxError"
            :setSkuCode="setSkuCode"
            :setSkuSizeCode="setSkuSizeCode"
            :setErrorText="setErrorText"
            :updateItemInBoxStatus="updateItemInBoxStatus"
            :purchasableSkus="purchasableSkus"
        />
        <!-- NU_FEATURE: fitGuidance -->
        <!-- https://urbnit.atlassian.net/browse/TYP-35400 -->
        <template v-if="featureManager.features.fitGuidance">
            <ProductFitSizeRecommender
                :fitGuidance="fitGuidance"
                class="u-spacer--4"
            />
            <ProductFitSliderScaleV2
                :reviewSummary="reviewSummary"
                :fitGuidance="fitGuidance"
                class="u-spacer--2"
            />
        </template>
        <ProductFitSliderScale
            v-else
            :reviewSummary="reviewSummary"
            class="u-spacer--2"
        />
        <BaseSupportingTextError
            :errorText="addToBoxError"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useFeatureManager } from '~coreModules/core/js/composables/useFeatureManager';

import BaseSupportingTextError from '~coreModules/core/components/ui/form-elements/BaseSupportingTextError.vue';
import ColorSizeSelector from '~modules/core/components/ui/ColorSizeSelector.vue';
import ColorSelector from '~modules/core/components/ui/ColorSelector.vue';
// NU_FEATURE: fitGuidance
// https://urbnit.atlassian.net/browse/TYP-35400
// remove ProductFitSliderScale when feature is complete
import ProductFitSliderScale from '~routes/product/components/ProductFitSliderScale.vue';
import ProductFitSliderScaleV2 from '~routes/product/components/ProductFitSliderScaleV2.vue';
import ProductFitSizeRecommender from '~routes/product/components/ProductFitSizeRecommender.vue';

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    colorCode: {
        type: String,
        required: true,
    },
    choices: {
        type: Array,
        required: true,
    },
    sizeCodeAvailibilityByChoiceId: {
        type: Object,
        required: true,
    },
    selectedChoice: {
        type: Object,
        required: true,
    },
    selectedSku: {
        type: String,
        default: '',
    },
    selectedSkuSizeCode: {
        type: Object,
        default: null,
    },
    reviewSummary: {
        type: Object,
        default: () => ({}),
    },
    fitGuidance: {
        type: Object,
        default: () => ({}),
    },
    addToBoxError: {
        type: String,
        default: '',
    },
    serviceErrorMessage: {
        type: String,
        default: '',
    },
    updateSelectedColor: {
        type: Function,
        required: true,
    },
    setSkuCode: {
        type: Function,
        required: true,
    },
    setSkuSizeCode: {
        type: Function,
        required: true,
    },
    setErrorText: {
        type: Function,
        default: () => ({}),
    },
    updateItemInBoxStatus: {
        type: Function,
        default: () => ({}),
    },
    purchasableSkus: {
        type: Array,
        default: () => [],
    },
});

const { t } = useI18n();
const featureManager = useFeatureManager();

const colorSizeSelectorSpacer = computed(() => {
    if (!props.fitGuidance?.fitReviews?.length) {
        return props.reviewSummary?.fitRatingCount ? 'u-spacer--1' : 'u-spacer--2';
    }
    return '';
});
</script>
